import { Box, Typography } from '@mui/material'
import { PageHeader } from 'components/Shared/PageHeader'
import { isNil } from 'lodash'
import { type SystemBannerDTO } from 'types/api'

export const BannerDetailsHeader = ({
  banner,
}: {
  banner: SystemBannerDTO
}) => {
  if (!banner.id) {
    return <Typography>Banner Id must not be null.</Typography>
  }

  return (
    <Box>
      <PageHeader
        title={isNil(banner.title) ? 'Unknown' : banner.title}
        subtitle={`Banner Type: ${banner.type}`}
        backText="Banners"
        backPath="/Communications/Banners"
        isSecondary={true}
      />
    </Box>
  )
}
